<template>
  <common-filter-form :filter="filterForm" :fields="allFields" :default-common-fields="defaultCommonFields" :default-more-fields="defaultMoreFields" config-key="venueFilterConfig" @change="handleFieldChange" @search="handleSearch" @reset="handleReset">
    <template slot="field" slot-scope="{ field, form, reset, labelCol, wrapperCol }">
      <venue-filter-form-item
        :form="form"
        :field="field"
        :options="{
          statusList: venueStatusList,
          venueTypes: venueTypeList,
          projectOptions: projectOptions
        }"
        :search-data="{
          requirements: {
            searching: requirementSearching,
            data: searchRequirementData
          },
          teams: {
            searching: teamSearching,
            data: searchTeamData
          }
        }"
        :reset="reset"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        @change="handleFieldChange"
        @search="handleFieldSearch"
      />
    </template>
  </common-filter-form>
</template>

<script>
import { venueStatus, venueActivity } from '@/utils/venueConstants';

import CommonFilterForm from '@/components/CommonFilterForm';
import VenueFilterFormItem from './VenueFilterFormItem';

export default {
  name: 'VenueFilterForm',
  components: {
    CommonFilterForm,
    VenueFilterFormItem
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filterForm: { ...this.value },
      requirementSearching: false,
      teamSearching: false,
      searchRequirementData: [],
      searchTeamData: [],
      projectOptions: [],
      venueStatusList: Object.values(venueStatus),
      venueTypeList: Object.values(venueActivity),
      // 所有可用的筛选项配置
      allFields: [
        { key: 'name', label: '会场名称', span: 6 },
        { key: 'status', label: '会场状态', span: 6 },
        { key: 'activity', label: '会场类型', span: 6 },
        { key: 'creator', label: '创建人', span: 6 },
        { key: 'projects', label: '关联项目', span: 6 },
        { key: 'requirements', label: '竞拍需求', span: 6 },
        { key: 'teams', label: '参与团队', span: 6 },
        { key: 'dateRange', label: '时间筛选', span: 12, labelSpan: 3, wrapperSpan: 21 }
      ],
      // 默认常用筛选字段
      defaultCommonFields: ['name', 'status', 'activity'],
      // 默认更多筛选字段
      defaultMoreFields: ['creator', 'dateRange']
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.filterForm = { ...newVal };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleFieldChange({ key, value }) {
      this.$set(this.filterForm, key, value);
      this.handleSearch();
    },

    handleSearch() {
      this.$emit('change', this.filterForm);
      this.$emit('update:value', this.filterForm);
    },

    handleReset() {
      // 定义默认的筛选表单值
      const defaultForm = {
        time_field: 'create_time',
        start_time: null,
        end_time: null
      };
      // 更新表单数据
      this.filterForm = { ...defaultForm };
      this.$emit('reset', this.filterForm);
    },

    handleFieldSearch({ key, value }) {
      if (key === 'requirements') {
        this.searchRequirements(value);
      } else if (key === 'teams') {
        this.searchTeams(value);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.venue-filter-form {
  .filter-actions {
    display: flex;
    text-align: right;
    margin-left: auto;
    align-items: flex-start;
    justify-content: flex-end;
  }

  :deep(.ant-form-item) {
    margin-bottom: 0px;

    .ant-form-item-label {
      text-align: right;
      color: #495057;
      padding-right: 8px;
    }
  }

  :deep(.filter-popover) {
    .ant-popover-inner-content {
      padding: 0;
    }
  }

  .filter-popover-content {
    width: 520px;
    max-height: 70vh;
    overflow-y: auto;
    padding: 12px;

    .filter-sections {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .filter-section {
        h3 {
          margin-bottom: 4px;
          color: #495057;
          font-size: 13px;
          font-weight: 500;
          line-height: 1.2;
        }

        .field-list {
          .field-item {
            display: flex;
            align-items: center;
            cursor: move;

            .drag-handle {
              padding: 2px;
              cursor: move;
              opacity: 0.4;
              display: flex;
              align-items: center;
              transition: all 0.2s ease;

              &:hover {
                opacity: 0.7;
              }
            }

            :deep(.ant-form-item) {
              flex: 1;
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
</style>
